import React from 'react'
import { Link } from 'react-router-dom'
import BackToHome from '../../components/back-to-home'
import Navbar from '../../components/navbar_poc'
import Footer from '../../components/footer'
export default function Page404() {
  return (
    <>
   <Navbar/>
        <BackToHome/>
        <section className="bg-home d-flex align-items-center">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-md-12 text-center">
                        <div className="text-dark fw-bold mt-0 error-page">404!</div>
                        <div className="h3">Something's Missing</div>
                        <p className="text-muted para-desc mx-auto mt-4">The webpage your are looking for is not here !</p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 text-center">  
                        <Link to="/" className="btn btn-outline-primary mt-4">Go Back</Link>
                        <Link to="/" className="btn btn-primary mt-4 ms-2">Go To Home</Link>
                    </div>
                </div>
            </div>
        </section>
         <Footer/>
    </>
  )
}
